class SizeChartPDP extends HTMLElement {
  constructor() {
    super();

    this.currentStep = 0;

    this.steps = this.querySelectorAll(".size-chart-step");
    this.dots = this.querySelectorAll(".dot");

    this.opener = document.querySelector("size-chart-opener");
    this.closer = this.querySelectorAll(".popup-close");
    this.dropShadow = this.querySelector("#sizeModal");

    this.nextBtn = this.querySelector(".step-next");
    this.nextSteps = this.querySelectorAll(".size-chart-next");
    this.prevSteps = this.querySelectorAll(".size-chart-prev");

    this.heightCmInput = this.querySelector("#height-cm");
    this.heightFtInput = this.querySelector("#height-feet");
    this.heightInInput = this.querySelector("#height-inches");

    this.weightKgInput = this.querySelector("#weight-kg");
    this.weightLbsInput = this.querySelector("#weight-lbs");

    this.ageInput = this.querySelector("#age");

    this.hasSavedResult = !!localStorage.getItem("selected_size");

    this.editResponse = this.querySelector(".edit-response");
    this.unitToggle = this.querySelectorAll(".unit-toggle");

    this.bodyProfile = {
      chest: null,
      stomach: null,
      seat: null
    };

    if (this.hasSavedResult) {
      this.updateOpener(localStorage.getItem("selected_size"));
    }
  }

  connectedCallback() {
    this.opener?.addEventListener("click", () => {
      SizeChartPDP.open(this, this.hasSavedResult ? this.steps.length - 1 : 0);
    });

    this.closer.forEach(btn =>
      btn.addEventListener("click", () => SizeChartPDP.close(this))
    );

    this.addEventListener("click", e => {
      if (e.target === this.dropShadow) {
        SizeChartPDP.close(this);
      }
    });

    this.nextBtn?.addEventListener("click", () => this.nextStep());
    this.nextSteps.forEach(btn => btn.addEventListener("click", () => this.nextStep()));
    this.prevSteps.forEach(btn => btn.addEventListener("click", () => this.prevStep()));

    this.querySelectorAll(".popup-icon-btn").forEach(btn => {
      btn.addEventListener("click", () => {
        this.bodyProfile[btn.dataset.type] = btn.dataset.value;
      });
    });

    this.bindUnitSwitching();
    this.buttonState();

    this.editResponse?.addEventListener("click", () => this.resetSteps());
    this.unitToggle.forEach(t =>{
        const inputs = t.querySelectorAll("input");
        inputs.forEach(inp =>{
            inp.addEventListener("change",()=>{
                this.nextBtn.disabled = true;
            })
        })
    })
  }

  bindUnitSwitching() {
    this.heightCmInput?.addEventListener("input", () => {
      this.heightFtInput.value = "";
      this.heightInInput.value = "";
    });
    
    [this.heightFtInput, this.heightInInput].forEach(inp =>
        inp?.addEventListener("input", () => {
            this.heightCmInput.value = "";
        })
    );
    
    this.weightKgInput?.addEventListener("input", () => {
        this.weightLbsInput.value = "";
    });
    
    this.weightLbsInput?.addEventListener("input", () => {
        this.weightKgInput.value = "";
    });
  }


  nextStep() {
    if (this.currentStep >= this.steps.length - 1) return;

    this.steps[this.currentStep].classList.remove("current_step");
    this.dots[this.currentStep].classList.remove("active");

    this.currentStep++;

    this.steps[this.currentStep].classList.add("current_step");
    this.dots[this.currentStep].classList.add("active");

    if (this.currentStep === this.steps.length - 2) {
      this.autoMoveToResult();
    }
  }

  prevStep() {
    if (this.currentStep <= 0) return;

    this.steps[this.currentStep].classList.remove("current_step");
    this.dots[this.currentStep].classList.remove("active");

    this.currentStep--;

    this.steps[this.currentStep].classList.add("current_step");
    this.dots[this.currentStep].classList.add("active");
  }

  resetSteps() {
    this.currentStep = 0;

    this.steps.forEach(s => s.classList.remove("current_step"));
    this.dots.forEach(d => d.classList.remove("active"));

    this.steps[0].classList.add("current_step");
    this.dots[0].classList.add("active");

    [
      this.heightCmInput,
      this.heightFtInput,
      this.heightInInput,
      this.weightKgInput,
      this.weightLbsInput,
      this.ageInput
    ].forEach(i => i && (i.value = ""));

    this.nextBtn.disabled = true;
    localStorage.removeItem("selected_size");
    this.hasSavedResult = false;
    this.opener.innerHTML = "What's your size?";
  }

  autoMoveToResult() {
    setTimeout(() => {
      if (this.currentStep !== this.steps.length - 2) return;
      this.nextStep();
      this.showResult();
    }, 6000);
  }

  static open(el, step = 0) {
    el.classList.add("popup-open");

    el.steps.forEach(s => s.classList.remove("current_step"));
    el.dots.forEach(d => d.classList.remove("active"));

    el.currentStep = step;
    el.steps[step]?.classList.add("current_step");
    el.dots[step]?.classList.add("active");
  }

  static close(el) {
    el.classList.remove("popup-open");
    if (!el.hasSavedResult) el.resetSteps();
  }


  buttonState() {
    const allInputs = [
      this.heightCmInput,
      this.heightFtInput,
      this.heightInInput,
      this.weightKgInput,
      this.weightLbsInput,
      this.ageInput
    ];

    allInputs.forEach(input => {
      input?.addEventListener("input", () => {
        const hasHeight =
          this.heightCmInput.value ||
          this.heightFtInput.value ||
          this.heightInInput.value;

        const hasWeight =
          this.weightKgInput.value || this.weightLbsInput.value;

        this.nextBtn.disabled = !(hasHeight && hasWeight && this.ageInput.value);
      });
    });
  }


  showResult() {
    const size = this.calculateSize();

    localStorage.setItem("selected_size", size);
    this.hasSavedResult = true;
    this.updateOpener(size);

    document.querySelectorAll(".selected_size").forEach(el => {
      el.textContent = size;
    });
  }

  updateOpener(size) {
    this.opener.innerHTML = `
      <button class="selected_size_updated">
        <span>Your size: <b class="selected_size">${size}</b></span>
      </button>
    `;
  }


  calculateSize() {
  let weightKg = 0;

  // Normalize weight
  if (this.weightKgInput?.value) {
    weightKg = parseFloat(this.weightKgInput.value) || 0;
  } else if (this.weightLbsInput?.value) {
    weightKg = (parseFloat(this.weightLbsInput.value) || 0) * 0.453592;
  }

  const sizes = (this.dataset.sizes || "").split(",");
  if (!sizes.length || weightKg <= 0) return "";

  // PURE weight-based sizing
  if (weightKg < 75) return sizes[0];        // S
  if (weightKg < 85) return sizes[1];        // M
  if (weightKg < 100) return sizes[2];       // L
  if (weightKg < 120) return sizes[3];       // XL
  if (weightKg < 135) return sizes[4];       // XXL

  return sizes[5] || sizes[sizes.length - 1]; // XXXL / max
}
    }

if (!customElements.get("size-chart-pdp")) {
  customElements.define("size-chart-pdp", SizeChartPDP);
}